export default function getClasses(el) {
   const clazz = el.getAttribute('class') || '';
   return clazz.split(' ').filter(s => !!s);
}
